export function buildPresignedUploadFormData(
  fields: Record<string, string>,
  file: File,
  fileFieldName = "file"
): FormData {
  const formData = new FormData();
  Object.keys(fields).forEach((key) => {
    formData.append(key, fields[key]);
  });
  formData.append(fileFieldName, file);
  return formData;
}

export async function postPresignedMultipartForm(
  url: string,
  formData: FormData
): Promise<Response> {
  return fetch(url, { method: "POST", body: formData });
}

export function isPresignedUploadNoContentSuccess(response: Response): boolean {
  return response.status === 204;
}
